import Vue from 'vue';
import { modes } from './modes';

import {
  configure,
  extend,
  setInteractionMode,
  ValidationObserver,
  ValidationProvider
} from 'vee-validate';

import * as rules from 'vee-validate/dist/rules';
import * as custom_rules from './rules';
import { getDefaultMessage } from '@/plugins/vee-validate/messages/default';

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  bails: true,
  skipOptional: true,
  mode: 'iview-eager',
  useConstraintAttrs: true,
  defaultMessage: getDefaultMessage
});

modes.forEach(mode => setInteractionMode(mode.key, mode.handler));

const merge_rules = { ...rules, ...custom_rules };

for (const rule in merge_rules) {
  extend(rule, merge_rules[rule]);
}

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
